import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import TanksList from '~/containers/tanksList/tanksList';

export default class TanksPage extends Component {
  render() {
    const createButton = (
      <Link to="/tanks/create">
        <Button color="primary">New Tank</Button>
      </Link>
    );
    return (
      <Page>
        <TitleBar title="Tanks" button={createButton} />
        <TanksList />
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/tanks/tanks.jsx